import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import styled, { css } from "styled-components";

import Button from '../../components/Button';

interface IconHeaderProps {
    color: string;
}

interface TagItemProps {
    color: string;
}

interface BtnInsertNewAnswerProps {
    color: string;
}

export const Content = styled(DialogContent)`
    background-color: #f4f5f7;   
`;

export const ContentBody = styled(Grid)`
    display: flex;
    justify-content: center;
    height: auto;
    width: auto;
    margin-top: 15px;
    margin-bottom: 15px;
`;

export const DialogTop = styled.div`
    display: flex;
    padding-bottom: 15px;
    border-bottom: 1px solid #eef2f8;
    margin-top: 15px;
    width: 100%;
    
`;

export const DialogTopLeft = styled.div`
    width: 65%;
    height: 100%;
    display: flex;
    text-align: left;
    align-items: center;
    justify-content: start;
    margin-left: 15px;

    h1 {
        margin-left: 20px;
        font-size: 20px;
        font-weight: 500;
        color: black;
    }
`;

export const DialogTopCenter = styled.div`
    width: 25%;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
`;

export const DialogTopRight = styled.div`
    width: 10%;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
        width: 30px;
        border: none;
        background-color: transparent;
    }
`;

export const IconHeader = styled.span<IconHeaderProps>`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 60px;
    height: 100%;
    background-color: transparent;

    div {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 45px;
        height: 45px;
        background-color: #f4f4f4;
        border-radius: 50%;

        > svg {
            width: 25px;
            height: 25px;

            ${props => props.color && css`
                color: ${props.color} !important;
            `}
        }

    }
`;

export const BtnEditForm = styled.button`

    display: flex;
    margin-left: 0px !important;
    width: 100% !important;
    background-color: #f23b5c1a !important;
    border-radius: 10px;
    padding: 5px;
    justify-content: center;
    align-content: center;
    border: none;
    justify-items: center;
    align-items: center;

    svg {
      font-size: 11px;
      margin-right: 10px;
      margin-left: 5px;
    }

    h3 {
      font-size: 12px;
      font-weight: 500;
      margin-right: 5px;
    }

`;

export const ContainerItems = styled.div`
    width: 100%;
    margin-right: 15px;
    margin-left: 15px;
    margin-bottom: 20px;
    border-radius: 10px;
    width: 100%;
`;

export const DialogFooter = styled.div`
  border-top: 1px solid #eef2f8;
  padding: 15px !important;
  width: 100%;
`;

export const DialogFooterCenter = styled.div`
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
`;

export const BtnInsertNewAnswer = styled(Button) <BtnInsertNewAnswerProps>`
    height: 50px;
    width: 95%;
    background-color: #f23b5c;
    color: white;
    border-radius: 5px;
    border: 0;
    font-weight: 500;

    ${props => props.color && css`
        background-color: ${props.color} !important;
    `}
`;

export const HelpContainer = styled.div`
    margin-right: 15px;
    margin-left: 15px;
    margin-bottom: 20px;
    border-radius: 10px;
    background-color: #4680B81e;
    width: 100%;
`;

export const HelpItems = styled.div`
    padding: 15px;
    padding-bottom: 5px;
    width: 100%;
    height: 100%;
`;
export const HelpItem = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    justify-content: center;
    align-items: stretch;
`;
export const HelpIcon = styled.div`
    width: 10%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;

    svg {
        font-size: 25px;
        color: #4680B8;
    }
`;

export const HelpText = styled.div`
    width: 85%;
    font-size: 13px;
`;

export const TagContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-left: 5%;
    padding-right: 5%;
    margin-bottom: 10px;    
`;

export const TagItem = styled.div<TagItemProps>`
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    padding: 10px;
    width: 90%;

    ${props => props.color && css`
        background-color: ${props.color};
    `}

    :hover {

        ${props => props.color && css`
            //border: 2px solid ${props.color};
            background-color: ${props.color + "1a"};

            div {
                color: #4d4d4d;
            }
        `}
    }
`;

export const TagLeft = styled.div`
    width: 90%;
    color: white;
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
`;

export const TagRight = styled.div`
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
`;

export const TagEdit = styled.div`
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #4d4d4d;
    margin-left: 5px;

    svg {
        height: 14px;
        width: 14px;
    }

    :hover {
        height: 40px;
        border-radius: 5px;
        background-color: #4d4d4d1a;
    }
`;

export const ButtonAddNewLabel = styled(Button)`
    display: flex;
    justify-content: center !important;
    align-items: center !important;
    height: 40px;
    margin-left: 5%;
    margin-right: 5%;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #4d4d4d;
    background-color: #f4f5f7;
    border: 1px dashed #f23b5c;
    overflow: hidden;

    svg {
        width: 15px;
        height: 15px;
        color: #4d4d4d;
    }

    :hover {

        border: 1px dashed #f23b5c;
        background-color: #f4f5f7;
        color: #f23b5c;

        svg {
            color: #f23b5c;
        }

    }
`;

export const FormContainer = styled.div`
    width: 100%;
    padding: 20px;
    border-radius: 15px;
    background-color: white;
`;

export const FormHeader = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;

    svg {
        margin-right: 5px;
        height: 20px;
        width: 20px;
        color: #4d4d4d;
    }

    h3 {
        font-size: 15px;
        font-weight: 400;
        color: #4d4d4d;
    }

    :hover {
        border-radius: 5px;
        background-color: #4d4d4d1a;
    }
`;

export const FormContainerAdd = styled.div`
    
`;

export const FormContainerButtons = styled.div`
    float: right;

    button {
        width: 150px;
    }
`;

export const DropDownInfo = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #101820;
    font-weight: 400;
    font-size: 13px;
    margin-top: 10px;
    border-radius: 10px;
    padding: 10px;

    span { 
        margin-right: 5px;
        color: grey;
    }
`;

export const AutomaticData = styled.span`
    line-height: 1;
    margin: 0px 2px;
    padding: 3px 5px;
    white-space: nowrap;
    border-radius: 3px;
    font-size: 13px;
    border: 1px solid rgb(238, 238, 238);
    color: rgba(51, 51, 51, 0.9);
    background-color: rgb(248, 248, 248);
`;
